module.exports = __webpack_public_path__ + "static/media/previewOff.4fcddee8.svg";